// Sonave: on a visitor's first visit, switch to the language (and country)
// that matches where they are browsing from. Runs once; a manual choice in
// the country or language picker always wins afterwards.
(function () {
  var root = document.documentElement;
  try {
    if (window.Shopify && window.Shopify.designMode) return;
    if (/bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent)) return;
    var saved = localStorage.getItem('glow-geo') || '';
  } catch (e) {
    return;
  }

  var COUNTRY_LANGUAGES = {"CZ":"cs","SK":"sk","DE":"de","AT":"de","CH":"de|fr|it","LI":"de","FR":"fr","LU":"fr|de","MC":"fr","BE":"nl|fr|de","SN":"fr","CI":"fr","CM":"fr","MG":"fr","ML":"fr","BF":"fr","NE":"fr","TG":"fr","BJ":"fr","GA":"fr","CG":"fr","CD":"fr","GN":"fr","HT":"fr","RE":"fr","GP":"fr","MQ":"fr","GF":"fr","YT":"fr","PF":"fr","NC":"fr","PM":"fr","BL":"fr","MF":"fr","WF":"fr","TN":"fr","MA":"fr","DZ":"fr","ES":"es","MX":"es","AR":"es","CO":"es","PE":"es","VE":"es","CL":"es","EC":"es","GT":"es","CU":"es","BO":"es","DO":"es","HN":"es","PY":"es","SV":"es","NI":"es","CR":"es","PA":"es","UY":"es","PR":"es","GQ":"es","IT":"it","SM":"it","VA":"it","PL":"pl","NL":"nl","SR":"nl","AW":"nl","CW":"nl","SX":"nl","BQ":"nl","PT":"pt-PT|pt-BR","AO":"pt-PT|pt-BR","MZ":"pt-PT|pt-BR","CV":"pt-PT|pt-BR","GW":"pt-PT|pt-BR","ST":"pt-PT|pt-BR","TL":"pt-PT|pt-BR","BR":"pt-BR|pt-PT","SE":"sv","AX":"sv","DK":"da","GL":"da","FO":"da","FI":"fi","NO":"nb","SJ":"nb","HU":"hu","RO":"ro","MD":"ro","GR":"el","CY":"el","HR":"hr","BA":"hr","BG":"bg","SI":"sl","LT":"lt","BY":"ru","KZ":"ru","KG":"ru","TR":"tr","JP":"ja","KR":"ko","CN":"zh-CN","SG":"zh-CN","TW":"zh-TW","HK":"zh-TW","MO":"zh-TW","TH":"th","VN":"vi","ID":"id"};
  var current = {
    country: root.dataset.glowCountry,
    lang: (root.dataset.glowLocale || '').toLowerCase(),
    langs: (root.dataset.glowLocales || '').split(',').filter(Boolean),
    primary: root.dataset.glowPrimary || 'en'
  };

  function pickLanguage(country) {
    var wanted = (COUNTRY_LANGUAGES[country] || '').split('|').filter(Boolean);
    for (var i = 0; i < wanted.length; i++) {
      for (var j = 0; j < current.langs.length; j++) {
        var have = current.langs[j];
        if (have.toLowerCase() === wanted[i].toLowerCase() || have.split('-')[0].toLowerCase() === wanted[i].split('-')[0].toLowerCase()) return have;
      }
    }
    return current.primary;
  }

  function switchTo(country, lang) {
    var path = location.pathname;
    if (current.lang && current.lang !== current.primary.toLowerCase()) {
      var prefix = '/' + current.lang;
      if (path.toLowerCase() === prefix) path = '/';
      else if (path.toLowerCase().indexOf(prefix + '/') === 0) path = path.slice(prefix.length);
    }
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/localization';
    form.style.display = 'none';
    var fields = { form_type: 'localization', utf8: '✓', _method: 'put', return_to: path + location.search, country_code: country, language_code: lang };
    Object.keys(fields).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = fields[name];
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  }

  // Detected or chosen earlier: keep the visitor in that language on every page.
  var parts = saved.split(':');
  if (parts[0] === 'manual' && !parts[1]) return;
  if ((parts[0] === 'auto' || parts[0] === 'manual') && parts[1]) {
    if (parts[1].toLowerCase() !== current.lang) switchTo(parts[2] || current.country, parts[1]);
    return;
  }

  fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'browsing_context_suggestions.json?country%5Benabled%5D=true&language%5Benabled%5D=true', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var detected = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (!detected) return;
      var lang = pickLanguage(detected);
      try { localStorage.setItem('glow-geo', 'auto:' + lang + ':' + detected); } catch (e) {}
      if (detected === current.country && lang.toLowerCase() === current.lang) return;
      switchTo(detected, lang);
    })
    .catch(function () {});
})();
